export const getLinkToCurrentFileCss = (fileUrl: string): string => {
  const importUrl = new URL(fileUrl);
  importUrl.pathname = importUrl.pathname.replace(/\.js$/, '.css');
  return importUrl.toString();
};
